export enum CertificationRequirementRestriction {
  None = 'none',
  All = 'all',
  JobSubmission = 'jobSubmission',
  Placement = 'placement'
}

export class CertificationSectionConfig {
  required: boolean;
  certificationRestrictions: number[];
  certificationRestrictionsMode: 'includes' | 'excludes';
  certificationGroupRestrictions: number[];
  certificationGroupRestrictionsMode: 'includes' | 'excludes';
  saveBackToDataSource: boolean;
  displayStatusRestrictions: string[];
  requirementRestriction: CertificationRequirementRestriction;
  autoSelectFiles: boolean;

  constructor(
    required: boolean = true,
    certificationRestrictions: number[] = [],
    certificationRestrictionsMode: 'includes' | 'excludes' = 'includes',
    certificationGroupRestrictions: number[] = [],
    certificationGroupRestrictionsMode: 'includes' | 'excludes' = 'includes',
    saveBackToDataSource: boolean = true,
    displayStatusRestrictions: string[] = [],
    requirementRestriction: CertificationRequirementRestriction = CertificationRequirementRestriction.None,
    autoSelectFiles = false,
  ) {
    this.required = required;
    this.certificationRestrictions = certificationRestrictions;
    this.certificationRestrictionsMode = certificationRestrictionsMode;
    this.certificationGroupRestrictions = certificationGroupRestrictions;
    this.certificationGroupRestrictionsMode = certificationGroupRestrictionsMode;
    this.saveBackToDataSource = saveBackToDataSource;
    this.displayStatusRestrictions = displayStatusRestrictions;
    this.requirementRestriction = requirementRestriction;
    this.autoSelectFiles = autoSelectFiles;
  }

  static clone(config: CertificationSectionConfig): CertificationSectionConfig {
    return new CertificationSectionConfig(
      config.required,
      [...(config.certificationRestrictions ?? [])],
      config.certificationRestrictionsMode ?? 'includes',
      [...(config.certificationGroupRestrictions ?? [])],
      config.certificationGroupRestrictionsMode ?? 'includes',
      config.saveBackToDataSource ?? true,
      [...(config.displayStatusRestrictions ?? [])],
      config.requirementRestriction ?? CertificationRequirementRestriction.None,
      config.autoSelectFiles ?? false,
    );
  }
}
